
const GOOGLEMAPS_API_KEY = process.env.MIX_GOOGLEMAPS_API_KEY;
const BOOSTRAP_COLUMN_GRID = parseInt(process.env.MIX_BOOSTRAP_COLUMN_GRID);

const CDN_URL = process.env.MIX_CDN_URL;
const BUCKET_NAME = process.env.MIX_BUCKET_NAME;
const IMAGE_URL_BASE = {
	default_url: process.env.MIX_CDN_IMAGES_URL,
	uploads_url:process.env.MIX_CDN_IMAGES_URL + '/uploads/',
	events_url:process.env.MIX_CDN_IMAGES_URL + '/events/',
	teams_url:process.env.MIX_CDN_IMAGES_URL + '/teams/',
	entities_url:process.env.MIX_CDN_IMAGES_URL + '/entities/',
	default_image_url:process.env.MIX_CDN_URL + '/'+ process.env.MIX_BUCKET_NAME + '/'+ process.env.MIX_CDN_IMAGES_URL + '/defaults/car_park_default_invisible.jpg',
	default_team_image_url:process.env.MIX_CDN_URL + '/'+ process.env.MIX_BUCKET_NAME + '/'+ process.env.MIX_CDN_IMAGES_URL + '/defaults/team_default.svg',
};

const Vue = require('vue');
const HUB = new Vue();
window.Vue.prototype.$eventHubMainNav = new Vue();
const $basketController = window.Vue.prototype.$basketController = new Vue();

export  {
	$basketController,
	GOOGLEMAPS_API_KEY,
	HUB,
	BOOSTRAP_COLUMN_GRID,
	CDN_URL,
	BUCKET_NAME,
	IMAGE_URL_BASE
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/config.js